import React, { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import authService from '../../../services/authServices';
import { END_POINTS } from '../../../services/endpoint/endPoint';

const ForgetPassword = () => {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();

  const emailChangeHandler = (e) => {
    setEmail(e.target.value.toLowerCase());
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    authService.login(END_POINTS.ForgetPassword, {email:email}).then((res) => {
      console.log(res, "fpw *****")
      if (res.status === 200) {
        toast.success(res.data.message, {
          position: "top-right"
        });
        console.log(res.data.message)
        setTimeout(() => {
          navigate("/login");
        }, 6000)
      }
    }).catch((error) => {
      if (error.response) {
        toast.error(error.response.data.error, {
          position: "top-right"
          });
      }
    });
  };

  return (
    <>
      <ToastContainer />
      <div className="forget-password-wrapper login_wraper">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input type="email" className="form-control" placeholder="Enter your email" onChange={emailChangeHandler} required />
          </div>
          <button type="submit" className="btn">Request Password Reset</button>
          <a className='back-to-login' onClick={() => navigate('/login') }>Login ?</a>
        </form>
      </div>
    </>
  );
};

export default ForgetPassword;
